module.exports = __webpack_public_path__ + "static/media/arrow-new.6806b211.svg";